import { useState } from 'react'
import { Button } from '@chakra-ui/react'
import { LuCalendarPlus } from 'react-icons/lu'
import CreateEventDialog from './CreateEventDialog'

const CreateEventButton = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button size={{ base: 'xs', sm: 'sm' }} colorPalette="blue" onClick={() => setOpen(true)}>
        <LuCalendarPlus />
        Novo evento
      </Button>

      {open && (
        <CreateEventDialog
          open
          onOpenChange={setOpen}
        />
      )}
    </>
  )
}

export default CreateEventButton
